module.exports = __webpack_public_path__ + "assets/img/oneForOne_3.29fedf38.png";